
import ProductCardFilterLoader from '~/components/product/ProductCardFilterLoader.vue';
import SelectFilter from '~/components/filter/SelectFilter';
import RangeFilter from '~/components/filter/RangeFilter';
import PriceFilter from '~/components/filter/PriceFilter';
import { AppMixin } from '~/node_modules/sitis-nuxt/lib/mixins';

export default {
  name: 'Filters',

  data() {
    return {
      filterContainers: [],

      minPrice: '',
      maxPrice: '',

      selectedFiltersList: {},

      isVisibleFilter: false,
    };
  },
  components: {
    ProductCardFilterLoader,
    SelectFilter,
    RangeFilter,
    PriceFilter,
  },
  mixins: [AppMixin],
  emits: ['onCloceFilter', 'onChangeFilterVariant', 'searchProducts', 'onChangeFilterVariantPrice'],

  props: {
    selected: {
      type: Array,
      default() {
        return [];
      },
    },

    total: {
      type: Number,
      default: () => 0,
    },

    selectedFilters: {
      type: Object,
      default: () => ({}),
    },

    filterPrices: {
      type: Object,
      default: () => ({}),
    },

    categoryFilters: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    isLoading() {
      return Boolean(
        this.loadersMap.catalog
        || this.loadersMap.category
        || this.loadersMap.filters,
      );
    },

    isHasFilters() {
      return Boolean(Object.keys(this.selectedFilters).length);
    },

  },

  watch: {
    filterPrices() {
      this.initFilterPrice();
    },
    isHasFilters() {
      this.isVisibleFilter = this.isHasFilters;
    },
  },

  methods: {
    onFilter() {
      this.$emit('searchProducts', this.selectedFiltersList);
    },

    scrollSelectedFilter() {
      const element = document?.getElementById('tm-selectedFilters');

      if (this.selected.length) {
        element.scrollIntoView({ block: 'start' });
      }
    },

    // Инициализация фильтра стоимости
    initFilterPrice() {
      const minPrice = `${this.filterPrices?.selectedPrices?.[0]}` || '';
      if (
        this.minPrice !== minPrice
        && minPrice !== '0'
        && minPrice !== 'undefined'
      ) {
        this.minPrice = minPrice;
      }

      const maxPrice = `${this.filterPrices?.selectedPrices?.[1]}` || '';
      if (
        this.maxPrice !== maxPrice
        && maxPrice !== '0'
        && minPrice !== 'undefined'
      ) {
        this.maxPrice = maxPrice;
      }
    },

    // Логика радектирование стоимости
    changePrice(props) {
      const { minPrice, maxPrice } = props;

      this.maxPrice = maxPrice;
      this.minPrice = minPrice;

      this.setFilterPrice();
    },

    setFilterPrice() {
      const selectedPrice = {};
      let minPrice = this.minPrice || String(this.filterPrices?.minPrice) || '0';
      minPrice = (minPrice || '').replace(/\D+/g, '');

      let maxPrice = this.maxPrice || String(this.filterPrices?.maxPrice) || '0';
      maxPrice = (maxPrice || '').replace(/\D+/g, '');

      [
        { filterSlug: 'priceFrom', variantSlug: minPrice },
        { filterSlug: 'priceTo', variantSlug: maxPrice },
      ].forEach((item) => {
        const { filterSlug, variantSlug } = item;
        selectedPrice[filterSlug] = {
          [variantSlug]: variantSlug,
        };
      });

      this.selectedFiltersList = { ...this.selectedFiltersList, ...selectedPrice };
    },

    tapVariantRange(filterSlug, range) {
      const filterSelected = { ...this.selectedFilters };
      filterSelected[filterSlug] = {
        [range.join(':')]: range.join(':'),
      };

      this.selectedFiltersList = { ...this.selectedFiltersList, ...filterSelected };
    },

    onChangeFilterVariant(filterSlug, variantSlugs) {
      console.log(filterSlug, 'filterSlug');
      console.log(variantSlugs, 'variantSlugs');

      const filterSelected = { ...this.selectedFilters };
      filterSelected[filterSlug] = variantSlugs || {};

      if (variantSlugs === null || Object.keys(variantSlugs || {}).length <= 0) {
        delete filterSelected[filterSlug];
      }

      this.selectedFiltersList = { ...this.selectedFiltersList, ...filterSelected };

      console.log(this.selectedFiltersList, 'selectedFiltersList');
    },

    // onChangeFilterVariantPrice(value) {
    //   console.log(value, 'value');
    //   // this.$emit('onChangeFilterVariantPrice', value);
    // },

    clearFilters() {
      this.$emit('clearFilters');
    },

    changeVisibleFilter: function () {
      this.isVisibleFilter = !this.isVisibleFilter;
    },
  },

  mounted() {
    this.initFilterPrice();
    this.scrollSelectedFilter();

    this.selectedFiltersList = this.selectedFilters || {};

    this.$nextTick(() => {
      this.isVisibleFilter = this.isHasFilters;
    });
  },
};
